module.exports = __webpack_public_path__ + "assets/basic-arrow-down-71cbc2.svg";